import { render, staticRenderFns } from "./EditCompanyNotification.vue?vue&type=template&id=57a0b972&"
import script from "./EditCompanyNotification.vue?vue&type=script&lang=js&"
export * from "./EditCompanyNotification.vue?vue&type=script&lang=js&"
import style0 from "./EditCompanyNotification.vue?vue&type=style&index=0&id=57a0b972&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports